import { cx } from "../../lib/cx.js";
/* empty css            */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Stepper/Stepper.tsx
/** "Step 2 of 3 · Upload": the step label for a Drawer's description. `current` is from 1. */
function stepLabel(steps, current) {
	const index = Math.min(Math.max(1, current), steps.length);
	return `Step ${index} of ${steps.length} · ${steps[index - 1] ?? ""}`;
}
/**
* Where a multi-step flow is: "Step 2 of 3 · Upload" (Import org structure, Upload files,
* Pending upload), or a row of dots.
*/
function Stepper({ steps, current, variant = "label", "aria-label": ariaLabel = "Progress", className, ...rest }) {
	const index = Math.min(Math.max(1, current), steps.length);
	if (variant === "label") return /* @__PURE__ */ jsx("span", {
		...rest,
		className: cx("ds-stepper", "ds-stepper--label", className),
		children: stepLabel(steps, index)
	});
	return /* @__PURE__ */ jsx("ol", {
		...rest,
		"aria-label": ariaLabel,
		className: cx("ds-stepper", "ds-stepper--dots", className),
		children: steps.map((step, i) => {
			const position = i + 1;
			const state = position < index ? "complete" : position === index ? "current" : "upcoming";
			return /* @__PURE__ */ jsx("li", {
				className: cx("ds-stepper__dot", `ds-stepper__dot--${state}`),
				"aria-current": state === "current" ? "step" : void 0,
				children: /* @__PURE__ */ jsxs("span", {
					className: "ds-stepper__sr",
					children: [`Step ${position} of ${steps.length}: ${step}`, state === "complete" ? ", completed" : ""]
				})
			}, step);
		})
	});
}
//#endregion
export { Stepper, stepLabel };

//# sourceMappingURL=Stepper.js.map